import { GridRenderEditCellParams } from "@mui/x-data-grid";
import { TimePicker } from "@mui/x-date-pickers";
import { DateTime } from "luxon";
import { memo, useCallback } from "react";

const TimeCellEditor = memo((params: GridRenderEditCellParams) => {
    const { id, field, api } = params;

    const handleChange = useCallback(
        async (value: DateTime | null) => {
            await api.setEditCellValue({ id, field, value });
            api.stopCellEditMode({ id, field });
        },
        [api, field]
    );

    return (
        <div className="flex w-full h-full items-center pl-4 pr-2">
            <TimePicker
                autoFocus
                defaultValue={
                    typeof params.value === "string" ? DateTime.fromISO(params.value) || "00:00" : params.value
                }
                onAccept={handleChange}
                slotProps={{
                    field: {
                        onKeyDown: async (event) => {
                            const target = event.target as HTMLInputElement;
                            if (event.key === "Enter") {
                                const value: DateTime | string = params.value;

                                if (!value || typeof value === "string") return;

                                const newHour = parseInt(target.value.split(":")[0]);
                                const newMinute = parseInt(target.value.split(":")[1]);
                                const newTime = DateTime.fromObject({
                                    hour: newHour,
                                    minute: newMinute,
                                    day: value.day,
                                    month: value.month,
                                    year: value.year,
                                });

                                handleChange(newTime);
                            }
                            event.stopPropagation();
                        },
                    },
                }}
                ampm={false}
                sx={{
                    padding: 0,
                    "& .MuiInputBase-input": {
                        padding: 0,
                        height: "24px",
                        fontSize: "14px",
                    },
                    "& .MuiOutlinedInput-notchedOutline": {
                        display: "none",
                    },
                }}
            />
        </div>
    );
});

export default TimeCellEditor;
